import { FormGroup, ValidatorFn } from '@angular/forms';

export const REGEX_DOCUMENT = {
  BOLETA: '^B\\d{3}-\\d{7}$',
  FACTURA: '^F[A-Z0-9]{3}-\\d{7}$'
};

export class DocumentValidator {
  static valideForm(): ValidatorFn[] {
    return [DocumentValidator.DocumentCode()];
  }

  static DocumentCode(): ValidatorFn {
    return (fg: FormGroup): null => {
      const ctrlDocumentType = fg.controls['documentType'];
      const ctrlDocumentCode = fg.controls['documentCode'];
      const documentType = String(ctrlDocumentType.value);
      const documentCode = String(ctrlDocumentCode.value);

      if (documentType === 'FACTURA') {
        if (!documentCode.match(REGEX_DOCUMENT[documentType])) {
          ctrlDocumentCode.setErrors({
            notFactura: true,
            notBoleta: false
          });
          return null;
        }
      }
      if (documentType === 'BOLETA') {
        if (!documentCode.match(REGEX_DOCUMENT[documentType])) {
          ctrlDocumentCode.setErrors({
            notBoleta: true,
            notFactura: false
          });
          return null;
        }
      }
      ctrlDocumentCode.setErrors(null);
      return null;
    };
  }
}
